import React, { useMemo } from 'react';

import { Link as MuiLink } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';

export default function useReferencesTableData(references: string[]) {
    const data = useMemo(
        () =>
            references
                ?.filter((href) => {
                    try {
                        return new URL(href);
                    } catch (err) {
                        return false;
                    }
                })
                .map((href) => {
                    const url = new URL(href);
                    return {
                        href,
                        source: url.host.replace(/^www\./, '').replace(/\..+$/, ''),
                        link: url.host.startsWith('www.') ? url.host + url.pathname : 'www.' + url.host + url.pathname
                    };
                }) ?? [],
        [references]
    );

    const columns = useMemo<ColumnDef<(typeof data)[number]>[]>(
        () => [
            {
                header: 'Source',
                size: 200,
                accessorFn: ({ source }) => source,
                cell: (info) => info.renderValue()
            },
            {
                header: 'Link',
                minSize: 100,
                accessorFn: function Link({ link, href }) {
                    return (
                        <MuiLink href={href} color={'inherit'} target="_blank" rel="noopener noreferrer nofollow">
                            {link}
                        </MuiLink>
                    );
                },
                cell: (info) => info.renderValue()
            }
        ],
        []
    );

    return { data, columns };
}
